import React from 'react';
import styled from 'styled-components';

import Logo from '../assets/logo.svg';
import MyStoreIcon from '../assets/my_store.svg';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background-color: #172A2A;
  border-radius: 24px;
  padding: 40px;
  width: 90%;
  max-width: 500px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const HeaderSection = styled.div`
  background-color: #1F3737;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  align-self: center;
  width: fit-content;
`;

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Title = styled.h2`
  font-family: Ubuntu, sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
  text-align: center;
  margin: 0;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const OptionButton = styled.button`
  background-color: #1F3737;
  border: 2px solid #284640;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #609F94;
    background-color: #243A3A;
  }
  
  &:active {
    transform: translateY(1px);
  }
`;

const OptionIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #284640;
  border-radius: 8px;
  
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
`;

const OptionTitle = styled.span`
  font-family: Ubuntu, sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
`;

const OptionDescription = styled.span`
  font-family: Ubuntu, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #609F94;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 14px;
    height: 2px;
    background-color: #8B9494;
  }
  
  &::before {
    transform: rotate(45deg);
  }
  
  &::after {
    transform: rotate(-45deg);
  }
  
  &:hover {
    &::before,
    &::after {
      background-color: #A5B1B1;
    }
  }
`;

// Иконка Excel файла
const ExcelIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#24BA7D"/>
    <path d="M14 2V8H20" fill="#1F3737"/>
    <path d="M16 13L13 16L16 19M8 13L11 16L8 19" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

interface ImportSourceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectMyStore: () => void;
  onSelectExcel: () => void;
}

const ImportSourceModal: React.FC<ImportSourceModalProps> = ({
  isOpen,
  onClose,
  onSelectMyStore,
  onSelectExcel
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose} />

        <HeaderSection>
          <IconWrapper>
            <img src={Logo} alt="Logo" />
          </IconWrapper>
        </HeaderSection>

        <Title>Выберите источник данных</Title>

        <OptionsContainer>
          <OptionButton onClick={onSelectMyStore}>
            <OptionIcon>
              <img src={MyStoreIcon} alt="Мой склад" />
            </OptionIcon>
            <OptionContent>
              <OptionTitle>Мой склад</OptionTitle>
              <OptionDescription>Импорт товаров из системы "Мой склад"</OptionDescription>
            </OptionContent>
          </OptionButton>

          <OptionButton onClick={onSelectExcel}>
            <OptionIcon>
              <ExcelIcon />
            </OptionIcon>
            <OptionContent>
              <OptionTitle>Excel файл</OptionTitle>
              <OptionDescription>Загрузка товаров из Excel файла</OptionDescription>
            </OptionContent>
          </OptionButton>
        </OptionsContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ImportSourceModal;